enum SchoolCategoriesOptions {
  PUBLIC = 'Pública',
  PRIVATE = 'Privada',
}

enum SchoolCategory {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

const schoolCategoryFromOptionsMapper: any = {
  [SchoolCategoriesOptions.PUBLIC]: SchoolCategory.PUBLIC,
  [SchoolCategoriesOptions.PRIVATE]: SchoolCategory.PRIVATE,
};

const schoolCategoryToOptionsMapper: any = {
  [SchoolCategory.PUBLIC]: SchoolCategoriesOptions.PUBLIC,
  [SchoolCategory.PRIVATE]: SchoolCategoriesOptions.PRIVATE,
};

export {
  SchoolCategory,
  SchoolCategoriesOptions,
  schoolCategoryFromOptionsMapper,
  schoolCategoryToOptionsMapper,
};
